/**
 * Shared Jarvis status so the persistent widget and the pages (e.g. Home HUD
 * takeover) can react to whether Jarvis is currently active/awake.
 *
 * `briefing` lets the widget drive the HUD during the cinematic morning
 * briefing: { phase, focusId, focusName, color, photos, authors } — when set,
 * the HUD spotlights that project in the centre while Jarvis talks about it.
 */
import React, { createContext, useContext, useState } from "react";

const JarvisStatusContext = createContext(null);

export function JarvisStatusProvider({ children }) {
  const [active, setActive] = useState(false);
  const [briefing, setBriefing] = useState(null);
  return (
    <JarvisStatusContext.Provider value={{ active, setActive, briefing, setBriefing }}>
      {children}
    </JarvisStatusContext.Provider>
  );
}

export const useJarvisStatus = () =>
  useContext(JarvisStatusContext) || { active: false, setActive: () => {}, briefing: null, setBriefing: () => {} };
